export default {
  PAGE: 'page',
  FOLDER: 'folder',
};
